import { Stack } from '@mui/material'
import { memo } from 'react'

import Button from '../../shared/button/Button'
import StatusItem from './StatusItem'

const StatusUpgradeList = ({
  tiers,
  t,
  symbol,
  onPurchase,
  disabled,
  isProcessing
}) => {
  return (
    <Stack spacing={2} p={3}>
      {tiers.map(({ id, name, pointCost, isDisabled }, index) => {
        isDisabled = isDisabled || disabled
        return (
          <StatusItem
            key={index}
            t={t}
            id={id}
            name={name}
            pointCost={pointCost}
            symbol={symbol}
            actions={
              <Stack
                spacing={1}
                direction={{
                  xs: 'row',
                  sm: 'column'
                }}
                sx={{
                  alignItems: 'flex-end',
                  justifyContent: 'center'
                }}
              >
                {/* <Button
                  label={t('membership.get-with', { symbol: CURRENCIES.USD })}
                  onClick={() => onPurchase(CURRENCIES.USD, { id, name })}
                  disabled={isDisabled}
                /> */}
                <Button
                  label={t('membership.get-with', { symbol })}
                  onClick={() => onPurchase(symbol, { id, name, pointCost })}
                  disabled={isDisabled}
                  loading={isProcessing && !isDisabled}
                />
              </Stack>
            }
            sx={{
              opacity: isDisabled ? 0.4 : 1,
              pointerEvents: isDisabled ? 'none' : 'auto'
            }}
          />
        )
      })}
    </Stack>
  )
}

export default memo(StatusUpgradeList)
